exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-clickable{cursor:pointer}.rich-text-editor{border:1px solid #dcdcdc;font-family:\"serif\";border-radius:7px}.ProseMirror>grey-border-bottom{border:1px solid #dcdcdc}.ProseMirror>ul{padding:0 1em;list-style-type:disc}.ProseMirror>ol{padding:0 1.25em}.ProseMirror>h4{font-size:1.5rem;font-weight:700;padding-top:.25rem;padding-bottom:.25rem}.ProseMirror>hr{margin-top:1em;margin-bottom:1em;background-color:#6a6a6a}.ProseMirror p.is-editor-empty:first-child:before{content:attr(data-placeholder);float:left;color:#adb5bd;pointer-events:none;height:0}.is-vertically-resizable{resize:vertical}.is-max-height{height:100%}", ""]);

// exports
